import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppLayout from "./layout/app";
import BlankLayout from "./layout/blank";
import VueAnalytics from "vue-analytics";
import VueLodash from "vue-lodash";

import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/scss/theme.scss";
import "./assets/fonts/feather/feather.css";
// Font awesome import
import { library } from "@fortawesome/fontawesome-svg-core";
import { faHome } from "@fortawesome/pro-light-svg-icons/faHome";
import { faFillDrip } from "@fortawesome/pro-light-svg-icons/faFillDrip";
import { faWindow } from "@fortawesome/pro-light-svg-icons/faWindow";
import { faSwatchbook } from "@fortawesome/pro-light-svg-icons/faSwatchbook";
import { faCode } from "@fortawesome/pro-light-svg-icons/faCode";
import { faVectorSquare } from "@fortawesome/pro-light-svg-icons/faVectorSquare";
import { faDownload } from "@fortawesome/pro-light-svg-icons/faDownload";
import { faFilePlus } from "@fortawesome/pro-light-svg-icons/faFilePlus";
import { faShare } from "@fortawesome/pro-light-svg-icons/faShare";
import { faSlidersH } from "@fortawesome/pro-light-svg-icons/faSlidersH";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./registerServiceWorker";

Vue.use(VueLodash); // options is optional

library.add(
  faHome,
  faFillDrip,
  faWindow,
  faSwatchbook,
  faCode,
  faVectorSquare,
  faFilePlus,
  faDownload,
  faShare,
  faSlidersH,
  faInstagram,
  faFacebook,
  faTwitter
);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

Vue.use(VueAnalytics, {
  id: "UA-36457983-5",
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === "production"
  }
});

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("app-layout", AppLayout);
Vue.component("blank-layout", BlankLayout);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
